import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { trackEvent } from "../store/analyticsSlice";

interface NavigationListenerProps {
  children: React.ReactNode;
}

const getGenericPath = (pathname: string) => {
  if (pathname.startsWith("/documents/")) {
    return "/documents/:id"; // Generalize document detail pages
  }
  return pathname;
};

export const NavigationListener: React.FC<NavigationListenerProps> = ({
  children,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const genericPath = getGenericPath(location.pathname);
    dispatch(
      trackEvent({ name: "page_view", params: { page_path: genericPath } })
    );
  }, [location, dispatch]);

  return <>{children}</>;
};
